module.exports = __webpack_public_path__ + "static/media/summit-face-tip-3.aa0e4753.svg";